import { jsxs, jsx } from "react/jsx-runtime";
const IconVerifiedBadgeSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9.29 1.126a1 1 0 0 1 1.218-.278l1.525.736a1 1 0 0 0 .866.002l1.515-.722a1 1 0 0 1 1.213.279l1.082 1.359a1 1 0 0 0 .768.377l1.695.025a1 1 0 0 1 .958.769l.411 1.733a1 1 0 0 0 .519.66l1.553.792a1 1 0 0 1 .524 1.095l-.365 1.753a1 1 0 0 0 .184.81l1.083 1.42a1 1 0 0 1 0 1.212l-1.064 1.402a1 1 0 0 0-.181.815l.377 1.752a1 1 0 0 1-.528 1.103l-1.529.771a1 1 0 0 0-.524.669l-.394 1.712a1 1 0 0 1-.967.775l-1.682.013a1 1 0 0 0-.776.378l-1.062 1.336a1 1 0 0 1-1.217.278l-1.525-.736a1 1 0 0 0-.866-.002l-1.515.723a1 1 0 0 1-1.213-.28l-1.082-1.359a1 1 0 0 0-.768-.377l-1.695-.025a1 1 0 0 1-.958-.769l-.411-1.733a1 1 0 0 0-.519-.66l-1.553-.792a1 1 0 0 1-.524-1.095l.365-1.753a1 1 0 0 0-.184-.81L.96 13.064a1 1 0 0 1 0-1.212l1.064-1.402a1 1 0 0 0 .181-.815L1.83 7.883a1 1 0 0 1 .527-1.103l1.529-.771a1 1 0 0 0 .524-.669l.394-1.712a1 1 0 0 1 .967-.775l1.682-.013a1 1 0 0 0 .776-.378L9.29 1.126Z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.103 16.52a.996.996 0 0 1-.086-.079l-2.236-2.325a1.026 1.026 0 0 1 0-1.41l.01-.012a.933.933 0 0 1 1.357 0l1.663 1.73 5.509-5.73a.634.634 0 0 1 .913 0l.447.466a.634.634 0 0 1 0 .878l-6.448 6.706a.633.633 0 0 1-.914 0l-.215-.224Z"
        }
      )
    ]
  }
);
export {
  IconVerifiedBadgeSvg
};
